import React from "react";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
let TripAttendance = () => {
  let TableData = [
    {
      date: "JAN 4, 2022",
      tripTitle: "Phasellus sagittis eleifend...",
      destination: "Nullam tortor risus, varius...",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "WillowAnderson@gmail.com",
      phoneNumber: "1234567890",
      startDate: "4 March, 2022",
      endDate: "10 March, 2022",
      tripType: "international",
      price: "$2000",
      tutorName: "Willow Anderson",
      noOfStudent: 100,
      status: "Complated",
    },
    {
      date: "JAN 4, 2022",
      tripTitle: "Phasellus sagittis eleifend...",
      destination: "Nullam tortor risus, varius...",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "HenryOBrien@gmail.com",
      phoneNumber: "1234567890",
      startDate: "4 March, 2022",
      endDate: "10 March, 2022",
      tripType: "international",
      price: "$2000",
      tutorName: "Willow Anderson",
      noOfStudent: 70,
      status: "Complated",
    },
    {
      date: "JAN 4, 2022",
      tripTitle: "Phasellus sagittis eleifend...",
      destination: "Nullam tortor risus, varius...",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "WillowAnderson@gmail.com",
      phoneNumber: "1234567890",
      startDate: "4 March, 2022",
      endDate: "10 March, 2022",
      tripType: "day trip",
      price: "$2000",
      tutorName: "Willow Anderson",
      noOfStudent: 90,
      status: "Cancelled",
    },
    {
      date: "JAN 4, 2022",
      tripTitle: "Phasellus sagittis eleifend...",
      destination: "Nullam tortor risus, varius...",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "WillowAnderson@gmail.com",
      phoneNumber: "1234567890",
      startDate: "4 March, 2022",
      endDate: "10 March, 2022",
      tripType: "international",
      price: "$2000",
      tutorName: "Willow Anderson",
      noOfStudent: 100,
      status: "Complated",
    },
    {
      date: "JAN 4, 2022",
      tripTitle: "Phasellus sagittis eleifend...",
      destination: "Nullam tortor risus, varius...",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "HenryOBrien@gmail.com",
      phoneNumber: "1234567890",
      startDate: "4 March, 2022",
      endDate: "10 March, 2022",
      tripType: "international",
      price: "$2000",
      tutorName: "Willow Anderson",
      noOfStudent: 70,
      status: "Complated",
    },
    {
      date: "JAN 4, 2022",
      tripTitle: "Phasellus sagittis eleifend...",
      destination: "Nullam tortor risus, varius...",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "WillowAnderson@gmail.com",
      phoneNumber: "1234567890",
      startDate: "4 March, 2022",
      endDate: "10 March, 2022",
      tripType: "day trip",
      price: "$2000",
      tutorName: "Willow Anderson",
      noOfStudent: 90,
      status: "Cancelled",
    },
  ];
  return (
    <div>
      <div className="table-container">
        <div className="table-header">
          <p className="table-heading">Trip Attendance</p>
        </div>
        <div className="table-data-container">
          <table>
            <thead>
            <tr>
              <th className="trip-attendance-table-id-heading">ID</th>
              <th className="trip-attendance-table-date-heading">Date</th>
              <th className="trip-attendance-table-trip-title-heading">
                trip Title
              </th>
              <th className="trip-attendance-table-destination-heading">
                Destination
              </th>
              <th className="trip-attendance-table-country-heading">country</th>
              <th className="trip-attendance-table-state-heading">State</th>
              <th className="trip-attendance-table-city-heading">City</th>
              <th className="trip-attendance-table-email-heading">Email</th>
              <th className="trip-attendance-table-phone-heading">Phone</th>
              <th className="trip-attendance-table-start-date-heading">
                Start Date
              </th>
              <th className="trip-attendance-table-end-date-heading">
                End Date
              </th>
              <th className="trip-attendance-table-trip-type-heading">
                Trip Type
              </th>
              <th className="trip-attendance-table-price-heading">Price</th>
              <th className="trip-attendance-table-status-heading">Status</th>
              <th className="trip-attendance-table-action-heading"></th>
            </tr>
            </thead>
            {TableData.map((tableValue, tableIndex) => {
              return (
                <tr key={tableIndex}>
                  <td className="table-id-data">{tableIndex + 1}</td>
                  <td className="table-data">{tableValue.date}</td>
                  <td className="table-data">{tableValue.tripTitle}</td>
                  <td className="table-data">{tableValue.destination}</td>
                  <td className="table-data">{tableValue.country}</td>
                  <td className="table-data">{tableValue.state}</td>
                  <td className="table-data">{tableValue.city}</td>
                  <td className="table-email-data">{tableValue.email}</td>
                  <td className="table-data">{tableValue.phoneNumber}</td>
                  <td className="table-data">{tableValue.startDate}</td>
                  <td className="table-data">{tableValue.endDate}</td>
                  <td className="table-data">{tableValue.tripType}</td>
                  <td className="table-data">{tableValue.price}</td>
                  <td className="table-data">
                    <div
                      className="trip-attendance-table-status-card"
                      style={{
                        backgroundColor:
                          tableValue.status === "Cancelled"
                            ? "#FFB0B0"
                            : "#D2FFEB",
                        color:
                          tableValue.status === "Cancelled"
                            ? "#B80000"
                            : "#098B51",
                      }}
                    >
                      {tableValue.status}
                    </div>
                  </td>
                  <td className="table-data">
                    <select className="table-action-dropdown">
                      <option value="">Action</option>
                      <option value="View">View</option>
                    </select>
                  </td>
                </tr>
              );
            })}
          </table>
        </div>
        <div className="table-pagination-main">
          <Stack spacing={2}>
            <Pagination count={10} variant="outlined" shape="rounded" />
          </Stack>
        </div>
      </div>
    </div>
  );
};
export default TripAttendance;
